export const DOWNLOAD_FILE = 'DOWNLOAD_FILE';
export const DOWNLOAD_FILE_SUCCESS = `${DOWNLOAD_FILE}/SUCCESS`;
export const DOWNLOAD_FILE_FAILURE = `${DOWNLOAD_FILE}/FAILURE`;

export const DOWNLOAD_FILE_AS_BA = 'DOWNLOAD_FILE_AS_BA';
export const DOWNLOAD_FILE_AS_BA_SUCCESS = `${DOWNLOAD_FILE_AS_BA}/SUCCESS`;
export const DOWNLOAD_FILE_AS_BA_FAILURE = `${DOWNLOAD_FILE_AS_BA}/FAILURE`;


export default {
	DOWNLOAD_FILE,
	DOWNLOAD_FILE_SUCCESS,
	DOWNLOAD_FILE_FAILURE,

	DOWNLOAD_FILE_AS_BA,
	DOWNLOAD_FILE_AS_BA_SUCCESS,
	DOWNLOAD_FILE_AS_BA_FAILURE
};
